import Styled from 'styled-components';
import color from 'config/color';

const VerticalSeparator = Styled.div`
    width: 2px;
    background-color: ${props =>
      props ? props.theme.palette.primary['900'] : color.lightGrey};
    height: ${props => props.height};
`;

export default VerticalSeparator;
